import React from 'react';
import Box from '@mui/material/Box';
import { Chip, useMediaQuery } from '@mui/material';
import { WineBarOutlined, AccountBalanceOutlined, LandscapeOutlined, MapOutlined } from '@mui/icons-material';
import { useToursContext } from '../../../contexts/tour-context';
import currentLanguage from '../../../services/language';
import TourSearch from '../tour-search/tour-search.component';
import { t } from '@lingui/macro';
const WINERY_TYPE = 'winery';
const PLACE_TYPE = 'culture';
const NATURE_TYPE = 'nature';

export default function TourTags({ searchParams, setSearchParams }) {
    const { clickedTagValue, setClickedTagValue, setNoTagsClicked, tags } = useToursContext();
    const matches = useMediaQuery('(min-width:600px)');

    function iconForTypeOfPlace(type) {
        switch (type) {
            case WINERY_TYPE:
                return <WineBarOutlined />;
            case PLACE_TYPE:
                return <AccountBalanceOutlined />;
            case NATURE_TYPE:
                return <LandscapeOutlined />;
            default:
                return;
        }
    }

    function tagsHandleChange(id) {
        // isTourDrawerOpened && setIsTourDrawerOpened(false)
        if (clickedTagValue?.map(tag => tag.id).includes(id)) {
            setClickedTagValue(clickedTagValue.filter(tag => tag.id !== id))
            clickedTagValue.filter(tag => tag.id !== id).length === 0 && setNoTagsClicked(false)
        } else {
            setClickedTagValue([...clickedTagValue, ...tags?.filter(tag => tag.id === id)])
        }
    }

    let isTagClicked = (tag) => clickedTagValue?.map(tag => tag.id).includes(tag.id);

    let regionTag = null; // Default to no region

    if (window.location.hostname === 'winetour-northeast.bg') {
        regionTag = { id: 2, name: t`Район Мелник`, urlTo: 'https://winetour-southwest.bg/' };
    } else if (window.location.hostname === 'winetour-southwest.bg') {
        regionTag = { id: 1, name: t`Район Североизток`, urlTo: 'https://winetour-northeast.bg/' };
    }

    return (
        <Box sx={{ flexWrap: 'wrap', display: 'flex', justifyContent: 'flex-start', position: 'absolute', top: 5, left: 10, zIndex: 400, marginRight: matches ? 0 : 6 }}>
            {tags?.map((tag) =>
                <Chip key={tag.id} onClick={() => tagsHandleChange(tag.id)} icon={iconForTypeOfPlace(tag.type)} label={tag.name}
                    sx={{
                        textTransform: 'uppercase',
                        fontSize: 11, m: '4px',
                        bgcolor: isTagClicked(tag) ? 'green' : 'rgb(255 255 255 / 90%)',
                        color: isTagClicked(tag) ? 'white' : 'black',
                        fontWeight: isTagClicked(tag) ? '500' : '400',
                        '.MuiSvgIcon-root': { color: isTagClicked(tag) ? 'white' : 'gray' },
                        ':hover': { bgcolor: isTagClicked(tag) ? 'rgb(0 128 0 / 75%)' : 'rgb(255 255 255 / 65%)' }
                    }}
                />
            )}
            {regionTag &&
                <Chip key={regionTag.id}  onClick={() => window.parent.location.href = regionTag.urlTo} icon={<MapOutlined />} label={regionTag.name}
                    sx={{
                        textTransform: 'uppercase',
                        fontSize: 11, m: '4px',
                        bgcolor: 'rgb(255 255 255 / 90%)',
                        color: 'black',
                        fontWeight: '400',
                        '.MuiSvgIcon-root': { color: 'gray' },
                        ':hover': { bgcolor: 'rgb(255 255 255 / 65%)' }
                    }}
                />
            }
            {!matches && <TourSearch searchParams={searchParams} setSearchParams={setSearchParams} />}
        </Box>
    );
}